import { connect } from "react-redux"
import NumberStatsWidget from "QuorumGrassroots/widgets/NumberStats/components/index"
import { fullWidthWidgetConnection } from "QuorumGrassroots/widgets/selectors"

export default connect(fullWidthWidgetConnection, null)(NumberStatsWidget)
